module.exports = __webpack_public_path__ + "img/6ec0b90e56a2fb3d0e9b7e695e1a88c7.svg";